import { useRef } from 'react'
import styles from './RelatedPostsHorizontalScroller.module.scss'
import PostSizeS from '../PostSizeS/PostSizeS'
import { Array, Record, Static, String } from 'runtypes'
import { CategoryApiResponse, PostFromServer } from '../../../types'
import { getFileFullPath } from '../../../utils/Helpers'
//swiper imports
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/swiper.min.css'
import 'swiper/swiper-bundle.min.css'
import 'swiper/components/pagination/pagination.min.css'
import SwiperCore, {
  Mousewheel,
  Pagination,
  Autoplay,
  Navigation,
} from 'swiper'
SwiperCore.use([Autoplay])
SwiperCore.use([Mousewheel, Pagination, Navigation])

const RelatedPostsParameters = Record({
  sectionName: String,
  posts: Array(
    PostFromServer.And(
      Record({
        categories: Array(CategoryApiResponse),
      })
    )
  ),
})

type RelatedPostsParameters = Static<typeof RelatedPostsParameters>

const RelatedPostsHorizontalScroller = ({
  sectionName,
  posts,
}: RelatedPostsParameters) => {
  const prevRef = useRef<HTMLDivElement>(null)
  const nextRef = useRef<HTMLDivElement>(null)
  if (posts.length) {
    return (
      <div className={styles.RelatedPosts}>
        <div className={styles.TopLine}>
          <div className={styles.Left}>{sectionName}</div>
          <div className={styles.Right}>
            <div ref={prevRef} style={{ cursor: 'pointer' }}>
              <img
                className={styles.SliderArrow}
                src="/left-arrow.svg"
                alt="Left Arrow"
              />
            </div>
            <div ref={nextRef} style={{ cursor: 'pointer' }}>
              <img
                className={styles.SliderArrow}
                src="/right-arrow.svg"
                alt="Right Arrow"
              />
            </div>
          </div>
        </div>
        <Swiper
          slidesPerView={2}
          spaceBetween={1}
          style={{
            maxWidth: '650px',
            height: 'auto',
          }}
          navigation={{
            prevEl: prevRef.current,
            nextEl: nextRef.current,
          }}
          breakpoints={{ 650: { slidesPerView: 3, spaceBetween: 5 } }}
          onInit={(swiper: any) => {
            swiper.params.navigation.prevEl = prevRef.current
            swiper.params.navigation.nextEl = nextRef.current
            swiper.navigation.update()
          }}
        >
          {/* <div className={styles.PostsWrapper}> */}
          <div>
            {posts.map((post) => {
              return (
                <SwiperSlide key={post.id}>
                  <PostSizeS
                    post={{
                      title: post.name,
                      subtitle: post.name,
                      url: getFileFullPath(post.featured_image),
                      slug: post.slug,
                    }}
                    category={{
                      color: post.categories[0].color,
                      id: post.categories[0].id,
                      name: post.categories[0].name,
                    }}
                    subCategory={null}
                  />
                </SwiperSlide>
              )
            })}
          </div>
        </Swiper>
      </div>
    )
  }
  return null
}

export default RelatedPostsHorizontalScroller
